import { feedItems } from "@/mocks/jiukanliao";

export default function AlertsFeed() {
  return (
    <section id="alerts" className="bg-[#2a2318] py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="flex flex-col items-start">
            <span className="inline-flex items-center gap-2 rounded-full border border-[#f2d6a4] px-3 py-1 text-xs font-semibold tracking-[0.15em] text-[#ffd791]">
              <span className="h-1.5 w-1.5 animate-pulse-dot rounded-full bg-[#ff7a45]" />
              多图预警 · 图文猛料
            </span>
            <h2 className="font-display mt-4 text-3xl font-black leading-tight text-[#fff6e6] md:text-4xl">
              吃瓜快讯，实时滚动
            </h2>
            <p className="mt-4 max-w-2xl text-[15px] leading-7 text-[#f2e7d0]">
              图片爆料往往零散，这里按分钟滚动整理成标题加短摘要的快讯。多图预警的帖子会打上红标，让你优先点开信息量最大的那几条。
            </p>
          </div>
          <div className="hidden shrink-0 items-center gap-3 text-[#f2e7d0] md:flex">
            <i className="ri-radio-2-line text-2xl text-[#ff7a45]" />
            <div className="leading-tight">
              <p className="text-lg font-semibold">LIVE</p>
              <p className="text-[11px] tracking-wide text-[#b8a47f]">已整理 1,284 条猛料</p>
            </div>
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl bg-[#3a3121] ring-1 ring-[#5b4c31]">
          {feedItems.map((f, idx) => (
            <a
              key={f.no}
              href="#faq"
              className={`group flex items-start gap-4 p-4 transition hover:bg-[#453a27] md:gap-6 md:p-5 ${
                idx !== feedItems.length - 1 ? "border-b border-[#5b4c31]" : ""
              }`}
            >
              <span className="font-latin w-9 shrink-0 text-2xl font-bold text-[#ff9a63]">
                {f.no}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-[#7a3f1f] px-2.5 py-0.5 text-[11px] font-medium text-[#ffc79d]">
                    {f.tag}
                  </span>
                  <span className="flex items-center gap-1 text-[11px] text-[#b8a47f]">
                    <i className="ri-time-line" />
                    {f.time}
                  </span>
                </div>
                <h3 className="mt-2 text-[15px] font-semibold leading-snug text-[#fff6e6] md:text-base">
                  {f.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-[13px] leading-6 text-[#cbb98e]">
                  {f.summary}
                </p>
              </div>
              <span className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#5b4c31] text-[#ffd791] transition group-hover:bg-[#ff7a45] group-hover:text-white">
                <i className="ri-arrow-right-up-line" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}